import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, } from 'react-bootstrap';
import moment from 'moment';
import Confirm from '../../../../confirm/Confirm';
import UtilitiesService from '../../../../../service/UtilitiesService';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import Grid from '../../../../grid/Grid';

class BeaufortDetailedAccount extends React.Component {
  constructor(props) {
    super(props);
    const { account, } = this.props;
    const { ebillings, } = account;
    const headers = [];
    const rows = [];

    if (ebillings && ebillings.length > 0) {
      headers.push({
        value: 'id',
        display: 'Id',
      }, {
        value: 'customerId',
        display: 'Customer Id',
      }, {
        value: 'createdOn',
        display: 'Created On',
      });

      ebillings.forEach(record => rows.push({
        value: [ record._id, record.customerId, moment(record.createdOn), ],
        raw: {
          id: record._id,
        },
      }));
    }

    this.state = {
      ebillingHeaders: headers,
      ebillingRows: rows,
    };
  }

  BEAUFORT = 'beaufort';

  onEbillSelect(selectedRow) {
    const { ebillingRows, } = this.state;
    const ebill = ebillingRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedEbilling: ebill.raw,
    });
  }

  handleHide = () => {
    this.setState({ status: '', });
  };

  disableEbilling(ebillingId) {
    this.setState({ isLoading: true, }, () => {
      UtilitiesService.disableEbillingForAccount(this.BEAUFORT, ebillingId)
        .then(() => {
          this.setState({
            status: (
              <Alert className="mt-2" variant="success">
                <Alert.Heading>Success!</Alert.Heading>
                <p>{`Ebilling id ${ebillingId} has been removed successfully!`}</p>
                <div className="d-flex justify-content-end">
                  <Button onClick={this.handleHide} variant="outline-success">
                    OK
                  </Button>
                </div>
              </Alert>
            ),
          });
        })
        .catch(() => {
          this.setState({
            status: (
              <Alert className="mt-2" variant="danger">
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>{`Unable to remove ebilling id ${ebillingId}!`}</p>
                <div className="d-flex justify-content-end">
                  <Button onClick={this.handleHide} variant="outline-danger">
                    OK
                  </Button>
                </div>
              </Alert>
            ),
          });
        })
        .finally(() => {
          this.setState({ isLoading: false, removeEbillingOpen: false, });
        });
    });
  }

  showSelectedEbillingInfo(selectedEbilling) {
    const { isLoading, removeEbillingOpen, status, } = this.state;
    if (!selectedEbilling) {
      return null;
    }

    const handleRemoveEbillingOpen = () => {
      this.setState({ removeEbillingOpen: true, });
    };

    const handleRemoveEbillingClose = () => {
      this.setState({ removeEbillingOpen: false, });
    };

    return (
      <div className="container">
        <p>{`Selected ID: ${selectedEbilling.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <button type="button" className="btn btn-danger" onClick={handleRemoveEbillingOpen}>
              Remove Ebilling
            </button>
          </div>
          <Confirm
            isLoading={isLoading}
            title="Remove Ebilling Confirmation"
            content="Are you sure you want to remove this ebilling id?"
            open={removeEbillingOpen}
            onClose={handleRemoveEbillingClose}
            onYes={() => this.disableEbilling(selectedEbilling.id)}
            onNo={handleRemoveEbillingClose}
          />
        </div>
        {status}
      </div>
    );
  }

  render() {
    const { ebillingHeaders = [], ebillingRows = [], selectedEbilling, } = this.state;
    const { account, } = this.props;

    const items = VerticalLabelList.toList({
      Id: account.id,
      Pin: account.pin,
      'Rev Obj Id': account.revObjId,
      'Tax Year': account.taxYear,
      'External Account Id': account.externalAccountId,
      'Property Type': account.propertyType,
      'Created on': moment(account.createdOn)
        .utc()
        .format(),
      'Updated at': moment(account.updatedAt)
        .utc()
        .format(),
      'Effective Status': account.effectiveStatus,
      'Tag Description': account.tagDescription,
      'Asset Category': account.assetCategory,
      'Year New': account.yearNew,
      'Renewal Fee value': account.renewalFeeValue,
      'Commercial Address Owner': account.commAddressOwner,
      'Commercial Address Recipient': account.commAddressRecipient,
      'Commercial Address Street Number': account.commAddressStreetNumber,
      'Commercial Address Street Name': account.commAddressStreetName,
      'Commercial Address City': account.commAddressCity,
      'Commercial Address State': account.commAddressState,
      'Commercial Address Postal Code': account.commAddressPostalCode,
      'Commercial Address Conf': account.commAddressConf,
      'Situs Address Street Number': account.situsAddressStreetNumber,
      'Situs Address Street Name': account.situsAddressStreetName,
    });

    return (
      <div className="container">
        <div>
          <FieldSet title="Tax Account Summary" style={{ maxHeight: '400px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="E-billing" style={{ maxHeight: '400px', }}>
            <Grid
              headers={ebillingHeaders}
              rows={ebillingRows}
              onRowSelect={data => this.onEbillSelect(data)}
            />
          </FieldSet>
          {this.showSelectedEbillingInfo(selectedEbilling)}
        </div>
      </div>
    );
  }
}

BeaufortDetailedAccount.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
};

export default BeaufortDetailedAccount;
